<template>
  <div :class="isOverlay ? 'piramide-wrap overlayed' : 'piramide-wrap'">
    <div class="intro-pyramid">
      <div class="intro--page section--slide">
        <img class="logo-section" src="../assets/menu-item-balance.svg" />
        <h2 class="title-section">
          {{
            $i18n.locale == 'it' ?
            "PASTI MIGLIORI, MIGLIOR PIANETA"
            :
            "BETTER MEALS, BETTER PLANET"
          }}
        </h2>
        <p class="subtitle-section">
          {{
            $i18n.locale == 'it' ?
            "Scopri come due piramidi (per ogni cultura) siano meglio di una quando si tratta di scegliere alimenti che fanno bene a te e al pianeta!"
            :
            "Learn how two pyramids (for every culture) are better than one when it comes to choosing foods that are healthy for you and the planet!"
          }}
          </p>
      </div>
      <div class="intro--earth section--slide">
        <div class="intro-chat-wrap">
          <div class="intro-chat-earth">
            <div class="balloon-intro">
              <p>
                {{
                  $i18n.locale == 'it' ?
                  "La Doppia Piramide mostra quanto sono importanti le scelte alimentari per la tua come per la mia salute!"
                  :
                  "The Double Pyramid shows how important food choices are for your health and mine!"
                }}
                <br/><br/>
                {{
                  $i18n.locale == 'it' ?
                  "Ogni alimento ha una diversa impronta di carbonio, vale a dire la quantità totale di gas a effetto serra emessi durante tutte le fasi di produzione e distribuzione alimentare."
                  :
                  "Each food has a different carbon footprint, the total greenhouse gases emitted during all the phases of food production and distribution."
                }}
              </p>
            </div>
            <div class="button-intro" @click="showSlider">
              <p>
                {{
                  $i18n.locale == 'it' ?
                  "Giochiamo"
                  :
                  "Let's play!"
                }}
              </p>
            </div>
          </div>
          <img class="avatar-intro-earth" src="../assets/planet-intro-sdg.svg" />
        </div>
      </div>
    </div>
    <PyramidsSlider :startPyramidSlider="startPyramidSlider" :isOverlay="isOverlay" />
    <BadgesWrap  v-if="!isOverlay" :start="openBadgeType" :type="openBadgeType" :isOverlay="isOverlay" />

  </div>
</template>

<script>
import {mapState} from 'vuex';
import {preloadImages} from '../preload.js'
import {gsap, TimelineMax} from 'gsap'
import PyramidsSlider from './PyramidsSlider.vue'
import BadgesWrap from './BadgesWrap.vue'
export default {
  name: 'PyramidWrap',
  props: ['isOverlay', 'startPyramid'],
  data(){
    return {
      startPyramidSlider: false
    }
  },
  components:{
    PyramidsSlider,
    BadgesWrap
  },
 
  methods:{
    transitionIn(){
      this.$store.dispatch('setMenuCtaVisibility',!this.isOverlay);
      
      let TL = new TimelineMax();

      TL
      .to('.logo-section',{duration: .75, scale: 1, opacity:1, ease: 'Power2.easeOut'})
      .to('.title-section',{duration: .75, y: 0, opacity:1, ease: 'Power2.easeOut'},'-=.25')
      .to('.subtitle-section',{duration: .75, y: 0, opacity:1, ease: 'Power2.easeOut'},'-=.25')
      .to('.intro-pyramid',{duration: .75, x: '-100vw', ease: 'Power2.easeOut'},'+=3')
      .to('.avatar-intro-earth',{duration: .5, opacity:1, x: 0, ease: 'Power2.easeInOut'},'-=.25')
      .to('.balloon-intro',{duration: .5, opacity:1, ease: 'Power2.easeInOut'},'-=.25')
      .to('.button-intro',{duration: .5, opacity:1, ease: 'Power2.easeInOut'},'-=.25')
    },
    showSlider(){
      gsap.to('.intro-pyramid',{duration: .75, x: '-200vw', ease: 'Power2.easeOut'})
      gsap.to('.piramide-slider',{duration: .75, left: 0, ease: 'Power2.easeOut', onComplete: () => { this.startPyramidSlider = true}})
    }
  },
  mounted(){
    
	
		if(!this.isOverlay) {
      gsap.to('.piramide-wrap', {duration: .75, left: 0, ease: 'Power2.easeInOut'})
      this.$store.dispatch('setMenuCtaVisibility',true);
      setTimeout(this.transitionIn, 1000)
    }
	
  },
  watch: {
    startPyramid(val){
      if(val === true){
        gsap.to('.piramide-wrap', {duration: .75, left: 0, ease: 'Power2.easeInOut'})
        setTimeout(this.transitionIn, 1000)
      }
    }
  },
  computed:{
    ...mapState({
      openBadgeType: state => state.openBadgeType
    })
  }
}
</script>

<style lang="scss">
  .piramide-wrap{
    position: relative;
    top: 0;
    left: 0%;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    z-index: 4;
    background-color: #E2E7EC;
    &.overlayed{
      position: fixed;
      left: -100%;
      .intro-pyramid{
        flex-wrap: inherit;
      }
    }
    h2{
      font-weight: bold;
    }
    .intro-pyramid{
      position: relative;
      top: 0;
      left: 0;
      width: 200%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;   
      flex-wrap: wrap; 
      background-size: cover;
      background-image: url(/img/section-bg-pyramid.58eb0928.jpg);  
    }
    .section--slide{
      position: relative;
      height: 100vh;
      width: 100vw;
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      &.intro--page{
        img{
          margin: 0  auto;
          transform: scale(.7);
          opacity: 0;
          max-width: 300px;
          @media screen and(max-width: 767px){
            width: 80%;
          }
        }
        .title-section{
          margin: 30px auto 20px;
          transform: translateY(50px);
          opacity: 0;
          font-size: 48px;
          color: #000;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 24px;
            line-height: 30px;
            padding: 0 20px;
          }
        }
        .subtitle-section{
          margin: 0 auto 0;
          transform: translateY(50px);
          opacity: 0;
          color: #000;
          font-size: 32px;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 18px;
            line-height: 24px;
            padding: 0 20px;
          }
        }
      }
      &.intro--earth{
        justify-content: flex-start;
      }
    }
    .intro-chat-wrap{
      position: relative;
      width: 80%;
      margin: 0 auto;
      top: 10%;
      .intro-chat-earth{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0 80px;
        .balloon-intro{
          align-self: flex-start;
          padding: 50px 20px;
          background-color: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          font-size: 24px;
          opacity: 0;
        }
        .button-intro{
          text-align: right;
          margin: 20px 0 0 auto;
          border: 1px solid #2E70E2;
          background-color: #2E70E2;
          color: #fff;
          padding: 16px 20px;
          font-size: 18px;
          border-radius: 5px;
          cursor: pointer;
          opacity: 0;
        }
      }
      @media screen and(max-width: 860px){
        top: 50%;
        transform: translateY(-50%);
        .intro-chat-earth{
          padding: 0;
        }
      }
      @media screen and(max-width: 767px){
        width: 90%;
        .intro-chat-earth{
          .balloon-intro{
            padding: 20px 10px;
            font-size: 18px;
            line-height: 24px;
          }
        }
      }
    }
    .avatar-intro-earth{
      position: absolute;
      bottom: 0;
      transform: translateX(-100%) translateY(50%);
      left: 0;
      opacity: 0;
      width: 150px;
      @media screen and(max-width: 767px){
        width: 100px;
        transform: translateX(-100%) translateY(50%);
      }
    }
  }
</style>